import "./Home.module.css";
import Navigatie from "@/reusable_sections/Header";
import UwWoningAlsRendement from "./sections/UwWoningAlsRendement";
import InnovatieInVeiligheid from "./sections/InnovatieInVeiligheid";
import Benefits from "./sections/Benefits";
import WhatMakesABusinessSellReady from "./sections/WhatMakesABusinessSellReady";
import OnzeWegwijzers from "./sections/OnzeWegwijzers";
import StartUwCirculaireReis from "./sections/StartUwCirculaireReis";
import AgencyFootnote from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigatie />
      <UwWoningAlsRendement />
      <InnovatieInVeiligheid />
      <Benefits />
      <WhatMakesABusinessSellReady />
      <OnzeWegwijzers />
      <StartUwCirculaireReis />
      <AgencyFootnote />
    </div>;
}